import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  permissions: [],
  error: null,
  message: '',
};

const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PERMISSION_CREATE_REQUEST:
    case actionTypes.PERMISSION_GET_REQUEST:
    case actionTypes.PERMISSION_UPDATE_REQUEST:
    case actionTypes.PERMISSION_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.PERMISSION_CREATE_SUCCESS:
    case actionTypes.PERMISSION_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload,
      }
    case actionTypes.PERMISSION_UPDATE_SUCCESS:
    case actionTypes.PERMISSION_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.PERMISSION_CREATE_FAILURE:
    case actionTypes.PERMISSION_GET_FAILURE:
    case actionTypes.PERMISSION_UPDATE_FAILURE:
    case actionTypes.PERMISSION_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default permissionReducer
